/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const ArrowBigUp = [
  "svg",
  defaultAttributes,
  [["path", { d: "M9 18v-6H5l7-7 7 7h-4v6H9z" }]]
];

export { ArrowBigUp as default };
//# sourceMappingURL=arrow-big-up.js.map
